module.exports = __webpack_public_path__ + "img/facebook.2b2beec8.svg";